@let vState = state();
@if (dialog(); as vDialog) {
  <div class="dialog-header">
    <h2 class="heading-xl" i18n>Invite friends</h2>
    <button class="button tertiary" (click)="vDialog.close()">
      <div class="icon icon-x"></div>
      <span class="sr-only" i18n>Close</span>
    </button>
  </div>
}
@let tripInfo = trip();
@if (tripInfo.inviteUrl) {
  @if (vState?.isLoading) {
    <div class="empty-content">
      <div class="loading-spinner"></div>
      <p class="body-copy-sm text-anthracite" i18n>Revoking link...</p>
    </div>
  } @else {
  <p class="body-copy-sm text-anthracite" i18n>
    Share this link with your friends to invite them to join your trip.
  </p>
  <div class="link-container">
    <textarea
      #input
      (click)="input.select()"
      type="text"
      rows="6"
      class="link-input"
      [value]="linkText()"
      readonly></textarea>
    <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
    @if (isNativeShareSupported) {
      <button class="button primary" (click)="share(tripInfo.title, tripInfo.description, tripInfo.inviteUrl)">
        <div class="icon icon-share"></div>
        <span class="sr-only" i18n>Share link</span>
      </button>
    } @else {
      <button class="button primary sm" (click)="copyLink()">
        <div class="icon icon-copy"></div>
        <span i18n>Copy link</span>
      </button>
    }
    <!-- <button class="button tertiary" (click)="action.next('create')">
      <div class="icon icon-refresh-cw"></div>
      <span class="sr-only" i18n>Reset link</span>
    </button> -->
    <button class="button secondary danger sm" (click)="action.next('disable')">
      <div class="icon icon-x"></div>
      <span class="sm:sr-only" i18n>Revoke link</span>
    </button>
  </div>}
} @else {
  @if (vState?.isLoading) {
    <div class="empty-content">
      <div class="loading-spinner"></div>
      <p class="body-copy-sm text-anthracite" i18n>Creating link...</p>
    </div>
  } @else {
    <p class="body-copy-sm text-anthracite" i18n>
      You can invite friends to join your trip by sharing a link with them.
    </p>
    <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
  }
  <button class="button primary" [disabled]="vState?.isLoading" (click)="action.next('create')" i18n>
    Create link
  </button>
}

<hr />
<details class="faq-details">
  <summary class="faq-summary">
    <span>Sharing a link</span>
    <div class="icon icon-chevron-down"></div>
    <div class="icon icon-x"></div>
  </summary>
  <div class="faq-details-content">
    <p class="body-copy-sm text-anthracite">
      When sharing a link here are some things to keep in mind:
    </p>
    <ul class="body-copy-sm text-anthracite">
      <li>Anyone with the link can join the trip;</li>
      <li>Only the trip owner can revoke the link;</li>
      <li>
        Revoking the link will prevent anyone from joining the trip using the
        link;
      </li>
      <li>
        Resetting the link will create a new link and invalidate the old one;
      </li>
      <li>The trip owner can remove anyone from the trip;</li>
      <li>
        There is a maximum of
        <strong>5 participants</strong>
        limit for now.
      </li>
    </ul>
    <p class="body-copy-sm text-anthracite">
      This will change as AnotherTrip continues evolving.
    </p>
  </div>
</details>

<ng-template #errorTemplate>
  <div class="announcer" aria-live="polite" aria-atomic="true" tabindex="-1">
    <div class="form-errors">
      @if (state()?.error) {
        <div class="form-error">
          <div class="icon icon-alert-circle"></div>
          <p i18n>There was an error revoking the link. Please try again.</p>
        </div>
      }
    </div>
    @if (copied()) {
      <div class="form-info">
        <div class="icon icon-check-circle"></div>
        <p class="info-message" i18n>Copied to clipboard</p>
      </div>
    }
  </div>
</ng-template>
